import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { mobileOtpVerifyServices, SendMobileOTPServices } from "../../services";
import { timerCount } from "../../config";
import { toast } from "react-toastify";
const MobileVerificationOTPSend = ({
  setMobileverifyOtp,
  setMobileVerificationOTPSent1,
  setAdharOtp,
  setAdharNumber,
  setCurrentStep
}) => {
  const dispatch = useDispatch();
  const [mobile, setMobile] = useState("");
  const [msg, setMsg] = useState("");
  const [timer, setTimer] = useState(timerCount);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    const interval =
      timer > 0 && setInterval(() => setTimer((t) => t - 1), 1000);
    if (timer <= 0) setCanResend(true);
    return () => clearInterval(interval);
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (mobile.length !== 10) {
      setMsg("Please enter a valid 10-digit mobile number.");
      return;
    }

    try {
      const body = {
        mobileNumber: mobile,
        txnId: localStorage.getItem("txnId")
      };
      const response = await SendMobileOTPServices({ body });
      console.log(response, "===))-");
      if (response.status === true) {
        localStorage.setItem("newmobilenumber", mobile);
        // setMobileverifyOtp(true);
        // setAdharOtp(false)
        // setAdharNumber(false)
        // setMobileVerificationOTPSent1(true);
        setCurrentStep("MobileVerificationOTPVerify");
      } else {
        toast.error(response?.message || response?.result?.error?.message);
      }
    } catch (err) {
      console.error("Mobile verification failed", err);
      toast.error(
        err?.message ||
          err?.result?.error?.message ||
          "Mobile verification failed"
      );
    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA Address and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA Address.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA address.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="form-card content">
                <h3>Verify Your Mobile Number</h3>

                <form onSubmit={handleSubmit} className="pt-3">
                  <input
                    type="text"
                    maxLength="10"
                    placeholder="Enter Mobile Number"
                    value={mobile}
                    autoComplete="off"
                    onChange={(e) => setMobile(e.target.value)}
                    className="mobile-input mb-3"
                  />
                  {msg && <p style={{ color: "#cf1f1f" }}>{msg}</p>}
                  <button className="continue-btn" type="submit">
                    Verify
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default MobileVerificationOTPSend;
